import { createFileRoute } from "@tanstack/react-router";
import * as m from "~/paraglide/messages";
import { requireAuth } from "~/lib/auth-guard";
import { JobAlertSettings } from "~/components/JobAlertSettings";
import { RouteErrorBoundary } from "~/components/RouteErrorBoundary";
import { SubscriptionCard } from "~/components/settings/SubscriptionCard";
import { CreditUsageCard } from "~/components/settings/CreditUsageCard";
import { CreditPacksCard } from "~/components/settings/CreditPacksCard";
import { ReadingComfortCard } from "~/components/settings/ReadingComfortCard";
import { ConsentManagementCard } from "~/components/settings/ConsentManagementCard";

export const Route = createFileRoute("/settings")({
  beforeLoad: async () => { await requireAuth(); },
  component: SettingsPage,
  errorComponent: RouteErrorBoundary,
});

function SectionLabel({ children }: { children: React.ReactNode }) {
  return (
    <h2
      className="pt-2 text-xs font-semibold uppercase tracking-wider"
      style={{ color: "var(--text-muted)" }}
    >
      {children}
    </h2>
  );
}

function SettingsPage() {
  return (
    <div className="mx-auto w-full min-w-0 max-w-2xl py-6 sm:p-8" data-testid="settings-root">
      <div className="page-header animate-fade-up">
        <div className="min-w-0">
          <h1 className="page-title">{m.settings_title()}</h1>
          <p className="mt-1 text-sm" style={{ color: "var(--text-secondary)" }}>
            {m.settings_subtitle()}
          </p>
        </div>
      </div>

      <div className="mt-10 space-y-12">
        {/* Plan & Billing */}
        <section className="space-y-3">
          <SectionLabel>{m.settings_section_billing()}</SectionLabel>
          <SubscriptionCard />
          <CreditUsageCard />
          <CreditPacksCard />
        </section>

        {/* Integrations & Alerts */}
        <section className="space-y-3">
          <SectionLabel>{m.settings_section_integrations()}</SectionLabel>
          <JobAlertSettings />
        </section>

        {/* Preferences */}
        <section className="space-y-3">
          <SectionLabel>{m.settings_section_preferences()}</SectionLabel>
          <ReadingComfortCard />
          <ConsentManagementCard />
        </section>
      </div>
    </div>
  );
}
